export default __webpack_public_path__ + "dgh_sm.77dd3ca7.png";